<template>
  <div v-if="showCncAddress">
    <v-card outlined>
      <v-card-title>Collection Address</v-card-title>
      <v-card-text>
        <div v-if="retrieveCncAddress.address_line_1">{{retrieveCncAddress.address_line_1}}</div>
        <div v-if="retrieveCncAddress.address_line_2">{{retrieveCncAddress.address_line_2}}</div>
        <div v-if="retrieveCncAddress.address_line_3">{{retrieveCncAddress.address_line_3}}</div>
        <div v-if="retrieveCncAddress.address_line_4">{{retrieveCncAddress.address_line_4}}</div>

        <div v-if="retrieveCncAddress.postcode">{{retrieveCncAddress.postcode}}</div>
        <div v-if="retrieveCncAddress.telephone_no">{{retrieveCncAddress.telephone_no}}</div>
        <div v-if="showText" class="font-weight-bold">{{retrieveCncInfoText}}</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["retrieveCncAddress","retrieveCncInfoText"]),
    showCncAddress() {
      if (this.$store.getters.retrieveIsCncCustomer) {
        return true;
      }

      return false;
    },
    showText() {
      if (this.retrieveCncInfoText && this.retrieveCncInfoText != '') {
        return true
      }
      return false
    }
  }
};
</script>

<style lang="sass" scoped>
</style>